export default __webpack_public_path__ + "static/media/frame_en_pc.43c312be.png";